<template>
  <div>
    <card>
      <!-- Card header -->
      <h3 slot="header" class="mb-0">
        <span class="text-muted"># {{ orderindex }}. </span>{{ title }}
      </h3>
      <!-- Card body -->
      <!-- Input groups with icon -->
      <div class="row">
        <div class="col-md-2"><b>Duration</b></div>
        <div class="col-md-2">{{ duration }} week(s)</div>
        <div class="col-md-2"><b>Level</b></div>
        <div class="col-md-4">{{ level }}</div>
      </div>
      <div class="row">
        <div class="col-md-2"><b>Description</b></div>
        <div class="col-md-10"><span v-html="htmldescription(description)" /></div>
      </div>
    </card>
  </div>
</template>

<script>
import { ShowLink, HtmlNewLine } from "../../../services/helper";
export default {
  name: "stage-item",
  props: {
    title: String,
    duration: [String, Number],
    description: String,
    level: String,
    orderindex: [String, Number],
  },
  methods: {
    htmldescription(value) {
      return ShowLink(HtmlNewLine(value));
    },
  },
};
</script>